/**
 * @mixin
 * this mixin is extending the ParamTypeMixin and adds to the param DataInput functionality
 * the default tabs of the dataInput are params only, serving optional methods to extend it
 *
 * if working with RichTextBox, should be given 'ref="richEditor"' to the component
 *
 * Extended mixins: [ParamTypeMixin]
 */

import InListParamTypeMixin from './InListParamTypeMixin';
import ParamBaseDataInputMenuMixin from '../ParamBaseDataInputMenuMixin';

/**
 * For full functionality with RichTextEditor, should give ref="richEditor" to the component
 */
export default {
	mixins: [InListParamTypeMixin, ParamBaseDataInputMenuMixin],
	computed: {},
};
